<h3>Sign In</h3>
<div>
	<p-button
		label="Sign In with Google"
		(click)="onContinueWithGoogleClick()"></p-button>
</div>
